module.exports = __webpack_public_path__ + "img/iconControlValveMaterial.92b86d52.svg";